import React from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import PageContent from '../../components/page-content';
import { ProductCollectionSitemap as ProductCollectionSitemapType } from '../../types';
import HeaderBlock from './components/header-block';
import SitemapCollection from './components/sitemap-collections';

interface ProductCollectionHumanSitemap extends ProductCollectionSitemapType {
  name: string;
}

type Props = {
  data: {
    productCollectionSitemap: ProductCollectionHumanSitemap;
  };
};

export default ({ data }: Props) => {
  const { sitemapCollection, name } = data.productCollectionSitemap;
  const { t } = useAppContext();

  return (
    <PageContent withAds>
      <HeaderBlock
        title={t('category', 'product-collection-sitemap.heading', {
          title: name,
        })}
      />
      {sitemapCollection &&
        sitemapCollection.map((sCollection, index) => (
          <SitemapCollection
            key={index}
            sitemapItems={sCollection && sCollection.sitemapItems}
          />
        ))}
    </PageContent>
  );
};
